/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 *
 * fetch(), axios’taki BASE_PATH (subpath) kurallarını paylaşır; tek noktadan türetilir.
 */

const strip = (s: string) => s.replace(/\/+$/, '');
const useProxy = import.meta.env.VITE_USE_PROXY === 'true';

/**
 * Platform `Set-Cookie` `Path` çoğu kez `/api` veya `/api/auth` olur; istek yolu buna eşit önek ile başlamalı
 * (örn. `/api/...`). `https://host/core/api/...` pathname’i `/core/...` ile başladığından çerez *gönderilmez* →
 * korumalı uçlar 401. Bu bayrak: API ve DMS’i kökte `/api/...` ve `/dms/...` kullanır; SPA hâlâ `base: /core/`.
 */
function apiOnRootPath(): boolean {
  return import.meta.env.VITE_API_USE_ROOT === 'true';
}

export function withViteBasePathForApiDms(path: string): string {
  if (apiOnRootPath()) {
    return path;
  }
  const b = strip(import.meta.env.VITE_BASE_PATH || '');
  if (b && !path.startsWith(b) && (path.startsWith('/api/') || path.startsWith('/dms/'))) {
    return b + path;
  }
  return path;
}

export function getAppApiBaseUrl(): string {
  if (useProxy) return '';
  const explicit = strip(import.meta.env.VITE_API_BASE_URL || '');
  if (explicit) return explicit;
  if (import.meta.env.MODE === 'production') {
    if (apiOnRootPath()) {
      return window.location.protocol + '//' + window.location.host;
    }
    return window.location.protocol + '//' + window.location.host + strip(import.meta.env.VITE_BASE_PATH || '');
  }
  return '';
}
